module.exports = __webpack_public_path__ + "static/media/gallery_08.c312e121.png";